import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function NotFound() {
    return (
        <>
            <Helmet>
                <title>Pagina non trovata</title>
            </Helmet>
            <main className="lv-shell lv-stack">
                <section className="lv-card lv-card-pad">
                    <div className="lv-empty">
                        <div className="lv-empty-icon">
                            <FontAwesomeIcon icon={['fas', 'compass']} />
                        </div>
                        <h2 className="lv-title mb-2">Pagina non trovata</h2>
                        <p className="lv-subtitle mb-4">L&apos;indirizzo richiesto non esiste o è stato spostato.</p>
                        <Link to="/prenota" className="lv-btn lv-btn-primary lv-btn-pill">
                            Vai al calendario
                        </Link>
                    </div>
                </section>
            </main>
        </>
    );
}
